<template>
	<div>
		<div class="form-group">
			<ejs-combobox 
                v-model="reports" 
                :select='select' 
                :dataSource='dataSourceReports' 
                :fields='fieldsSourceProceso' 
                :showPopupButton='true' 
                cssClass="e-outline" 
                :placeholder="$t('textReports.textFormSelectReport')"
            />
        </div>
        <component v-bind:is="reports" :tittle="reportTittle"></component>
	</div>
</template>

<script>
export default {
	name: "reports-index-structuring",
	data(){
		return {
			reports : '',
			reportTittle : '',
			dataSourceReports: [
                { value: 'reports-form-detail-process', text: "Detalle procesos" },
                { value: 'reports-form-detail-audit', text: "Detalle auditoría" },
                { value: 'reports-form-audit-email-alerts', text: "Auditoría Emails Alertas" },
			],
			fieldsSourceProceso: { text: "text", value: 'value' },
		}
	},
	methods: {
		select: function(args) {
			this.reportTittle = args.itemData.text;
        },

        enableAffairReport(){
            const tenants = this.$store.getters['moduleTenants/tenants'];
            const current_tenant = tenants.find( tenant => tenant.tenants_id === localStorage.getItem('TID') );

            if( current_tenant && current_tenant.tenant_name.toUpperCase() == "SISTEMA CENTRAL" ){
                this.dataSourceReports = [
                    ...this.dataSourceReports,
                    { value: 'reports-form-detail-affairs', text: "Detalle asuntos" }
                ];
            } else {
                this.dataSourceReports = this.dataSourceReports.filter( report => report.value != 'reports-form-detail-affairs' );
            }
        }
	},
    created() {
        this.enableAffairReport();
        this.$eventHub.$on('onResetSwitchTenantsStructuring', this.enableAffairReport)
	},
}
</script>
